var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _circle4, _circle5, _circle6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect, _rect2, _path12, _circle7, _circle8, _ellipse, _ellipse2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _mask, _rect3, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhysiotherapy = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 329,
  height: 336,
  fill: "none",
  viewBox: "0 0 329 336"
}), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 160.5,
  cy: 175.123,
  r: 160,
  fill: "#D9EDFF"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 160.5,
  cy: 175.123,
  r: 160,
  stroke: "#D9EDFF"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 160.5,
  cy: 175.123,
  r: 160,
  stroke: "#000",
  strokeOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m107.5 208.123 6.5-58.5-55 4.5 3.5 54z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#B0D9FF",
  d: "M176 292.623c38.926 0 74.16 1.454 99.656 3.805 12.751 1.176 23.052 2.574 30.157 4.123 3.557.775 6.286 1.583 8.117 2.407.917.414 1.579.819 2.006 1.206.427.388.564.707.564.959 0 .251-.137.57-.564.959-.427.386-1.089.792-2.006 1.205-1.831.824-4.56 1.632-8.117 2.407-7.105 1.549-17.406 2.947-30.157 4.123-25.496 2.351-60.73 3.806-99.656 3.806s-74.16-1.455-99.656-3.806c-12.751-1.176-23.052-2.574-30.157-4.123-3.557-.775-6.286-1.583-8.117-2.407-.916-.413-1.58-.819-2.005-1.205-.428-.389-.565-.708-.565-.959 0-.252.137-.571.565-.959.426-.387 1.089-.792 2.005-1.206 1.83-.824 4.56-1.632 8.117-2.407 7.105-1.549 17.406-2.947 30.157-4.123 25.496-2.351 60.73-3.805 99.656-3.805Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M159.5 173.623v35h-28v-28a8 8 0 0 0-8-8H76v-23h59.5c13.255 0 24 10.745 24 24M79 84.623l-8 2.5 18 40 15.5-38-7-4.5v-8H79z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M119 52.623v-20c0-15.74-12.76-28.5-28.5-28.5S62 16.883 62 32.623v12c-2.5.333-7.5 2.2-7.5 7s5 6.666 7.5 7c0 12.426 10.074 22.5 22.5 22.5h6c15.74 0 28.5-12.76 28.5-28.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M69.5 25.123c-.4 14-10.5 21.833-15.5 24-.722-6.985-.633-13.36.36-19-7.641-3-16.86-13.5-7.86-24 7.731-9.02 18.833-2.734 23 1.15 6.075-3.322 14.005-4.968 24-4.65 25.2.8 29.167 27.666 28 41-17.2.4-41.833-12.167-52-18.5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M69.5 7.272c6.075-3.321 14.005-4.967 24-4.65 25.2.8 29.167 27.667 28 41-17.2.4-41.833-12.166-52-18.5-.4 14-10.5 21.834-15.5 24-.722-6.984-.633-13.359.36-19M69.5 7.272c-4.167-3.883-15.269-10.169-23-1.15-9 10.5.219 21 7.86 24M69.5 7.272c-8.46 4.626-13.32 12.502-15.14 22.85"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 47.499,
  r: 4,
  fill: "#020064"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 47.499,
  r: 4,
  fill: "#020064"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 55.123,
  r: 4,
  fill: "#B0D9FF"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M85 63.623c2.667 2 9.8 4.8 17 0"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m224.5 157.623 4.5-9 20 7-7.5 13.5z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "M68.5 205.623v32h-23v-45h10c7.18 0 13 5.82 13 13M175 237.623l-17-32 28-9.297-5.5-6.827c3.5-2.5 18.7-18.076 25.5-24.876 8.5-8.5 21.5-12 30-5 6.8 5.6 8.167 16.333 8 21l-61.5 57z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m221 190.123-26 17.376-14.5-18c3.5-2.5 18.7-18.076 25.5-24.876 8.5-8.5 21.5-12 30-5 6.8 5.6 8.167 16.333 8 21l-61.5 57H175l-17-32 28-9.297M68.5 237.623v-32c0-7.18-5.82-13-13-13h-10v45z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeWidth: 3,
  d: "M283.321 181.334a10.49 10.49 0 0 1 14.576-.174c4.333 4.085 4.402 10.954.15 15.124l-68.66 67.339h-29.239z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeWidth: 3,
  d: "M248.3 176.576c8.07-7.492 20.378-8.042 29.085-1.3l6.085 4.712-85.004 83.135H36.25v-3.084c0-12.427 10.074-22.5 22.5-22.5h123.883l.43-.401z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M68 206.123h91l17 31.5H68z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 33,
  x: 284.5,
  y: 271.623,
  fill: "#fff",
  stroke: "#020064",
  strokeWidth: 3,
  rx: 10.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 33,
  x: 49.5,
  y: 271.623,
  fill: "#fff",
  stroke: "#020064",
  strokeWidth: 3,
  rx: 10.5
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeWidth: 3,
  d: "M272.174 65.593c16.699 7.168 24.427 26.516 17.26 43.216l-5.612 13.075 1.158.666a6.998 6.998 0 0 1-.552 12.431 7 7 0 0 1-4.933.348l-1.28-.382-.527 1.228c-6.949 16.189-25.705 23.68-41.894 16.732l-.926-.398c-16.7-7.168-24.427-26.517-17.259-43.217l11.348-26.44c7.168-16.7 26.517-24.427 43.217-17.26Z"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 265,
  cy: 126.499,
  r: 4,
  fill: "#B0D9FF"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 227,
  cy: 110.499,
  r: 4,
  fill: "#B0D9FF"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 261.232,
  cy: 112.586,
  fill: "#020064",
  rx: 4.5,
  ry: 5,
  transform: "rotate(25.898 261.232 112.586)"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 238.232,
  cy: 103.586,
  fill: "#020064",
  rx: 4.5,
  ry: 5,
  transform: "rotate(25.898 238.232 103.586)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m235.883 83.223-5.718 3.32c-2.297 1.334-4.844-.698-3.683-3.088 5.341-10.997 16.927-22.332 31.518-22.332 16 0 29 9 34.5 24.5 3.708 10.45-.846 23.883-6.361 32.339-1.264 1.938-4.044 1.402-4.766-.797l-6.692-20.395a13 13 0 0 0-8.931-8.488l-22.215-6.059a10 10 0 0 0-7.652 1"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m109.5 123.123 4 26h-25v-26l14.5-35.5 6.76 3.82a19 19 0 0 1 7.342 7.462L140 140.999l5.981 8.906c2.988 4.449 1.594 10.498-3.04 13.19-4.59 2.667-10.478.943-12.906-3.778l-4.535-8.818z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m140 140.999-22.898-42.094a19 19 0 0 0-7.342-7.461L103 87.622l-14.5 35.501v26h25l-4-26 16 27.376m14.5-9.5 5.981 8.906c2.988 4.449 1.594 10.498-3.04 13.19-4.59 2.667-10.478.943-12.906-3.778l-4.535-8.818m14.5-9.5-14.5 9.5"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M45.5 144.623c0-38 8.333-45 14-49.5l8 5v9.5l21 14v26H62v12.816c-9.98-2.559-16.5-7.807-16.5-17.816"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M62 149.623v-27m0 27h26.5v-26l-21-14v-9.5l-8-5c-5.667 4.5-14 11.5-14 49.5 0 10.009 6.52 15.257 16.5 17.816z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "m88 123.623 15-37 14 8-8.5 7.5v8zl-21-13.5v-10l-7.5-5.5 14-8z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m88 123.623 15-37 14 8-8.5 7.5v8zm0 0-14.5-37-14 8 7.5 5.5v10z"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "path-33-inside-1_815_610",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 303,
  height: 23,
  x: 26,
  y: 262.123,
  rx: 1
}))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 303,
  height: 23,
  x: 26,
  y: 262.123,
  fill: "#fff",
  stroke: "#020064",
  strokeWidth: 6,
  mask: "url(#path-33-inside-1_815_610)",
  rx: 1
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M230 128.623c1.333 4 6.8 10.9 18 6.5"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M76 141.123v32H53v-45h10c7.18 0 13 5.82 13 13"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M137 215.999c25.649-4.758 37.615-18.051 44.749-25.187l12.751 16.187c-3.5 3-8 8-27.983 19.983-24.074 14.437-33.277 6.188-35.805 2.499-1.712-2.499-2.863-10.742 6.288-13.482"
})));
export { SvgPhysiotherapy as ReactComponent };